import script from "./NewLoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewLoginView.vue?vue&type=script&setup=true&lang=ts"

import "./NewLoginView.vue?vue&type=style&index=0&id=f2aa5d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2aa5d66"]])

export default __exports__